import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getPassportData = createAsyncThunk("api/passport-renewal", async (token) => {
    try {
        const response = await nodeinstance.get("/passport-renewal", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const PossportDataSlice = createSlice({
    name: "Driving",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPassportData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getPassportData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getPassportData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getPassportData };
export default PossportDataSlice.reducer;
